export const topBarHeight = 64;
export const navbarHeight = 60;
export const sideNavWidth = 260;
export const sidenavCompactWidth = 80;
export const containedLayoutWidth = 1200;

export const semesters = (t) => [
    {id: 1, name: t("academics.semester 1")},
    {id: 2, name: t("academics.semester 2")},
    {id: 3, name: t("academics.semester 3")},
    {id: 4, name: t("academics.semester 4")},
];